import { components } from '@witkac/bootstrap4-components';

// @vuese
// komponent Mixin
export const componentMixin = {
  components,
  props: {
    // @vuese
    // Przekazanie schematu do wpisania wartości komponentu
    model: {
      type: Object,
      required: false
    },

    // @vuese
    // Przekazanie schematu do wpisania wartości komponentu
    modelItems: {
      type: Array,
      required: false
    },

    // @vuese
    // Przekazanie tytułu
    title: { type: String, required: false },

    // @vuese
    // Czy pola mają być disabled
    // dostępne opcje `{ modelProperty: Boolean, all: Boolean }`
    disabled: {
      type: Object,
      required: false,
      default: () => ({})
    },

    // @vuese
    // Czy pola mają pokazywać komunikaty błędów
    // dostępne opcje `{ modelProperty: Boolean, all: Boolean }`
    hideError: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    // @vuese
    // Zwraca property `all` lub podane property
    checkProperty(container, property) {
      return container ? container.all || container[property] || false : false;
    },
    // @vuese
    // Zwraca property `all` lub podane property w obiekcie `this.disabled`
    checkDisabled(property) {
      return this.checkProperty(this.disabled, property);
    },
    // @vuese
    // Zwraca property `all` lub podane property w obiekcie `this.hideError`
    checkHiddenError(property) {
      return !this.checkProperty(this.hideError, property);
    }
  },
  computed: {
    getTitle() {
      if (this.title) {
        return this.title;
      }
      return this.model.$title;
    }
  }
};
